import React from 'react';
import '../style/chart.scss';
import { getDecisionPieChartConfig } from '../getPieChartConfig';
import { juridictionBaseH } from './juridictionChart.utils';
import { LazyReactChart } from '../LazyReactChart';

type Props = {
  handleClick?: (wantToOpenInNewTab: boolean, index: number | null) => void;
  data: Array<number>;
  labels: Array<string>;
};

export class JuridictionsChart extends React.Component<Props> {
  static defaultProps = { handleClick: () => {} };

  render() {
    const { data, labels, handleClick } = this.props;
    return (
      <div className="chart">
        {data.length > 0 && (
          <LazyReactChart
            config={getDecisionPieChartConfig({
              data,
              labels,
              handleClick,
              baseH: juridictionBaseH,
            })}
          />
        )}
      </div>
    );
  }
}
